const searchInput = document.querySelector('#search-blogs');
const clearButton = document.querySelector('.blog--search-clear');
const articlesContainer = document.querySelector('#blog-articles');
const noResults = document.querySelector('.no-results');
const resultsCount = document.querySelector('.blog-search__results-count');
const paginationWrapper = document.querySelector('.pagination-wrapper');
const loadMoreButton = document.querySelector('.load-more');
const filterButton = document.querySelector('.blog__filter-button');
const filterDrawer = document.querySelector('.block__blog-filter-drawer');
const filterCloseIcon = document.querySelector('.blog__filter-close-icon');
const filterOverlay = document.querySelector('.block__blog-overlay');
const filterContent = document.querySelector('.block__blog-filter-content');
const filterHeader = document.querySelector('.block__blog-filter-inner-header p');
const suggestionsContainer = document.querySelector('#blog-search-suggestions');

let originalArticlesHTML = articlesContainer.innerHTML;
//   {% comment %} console.log('Original articles HTML:', originalArticlesHTML); {% endcomment %}
let currentPage = 1;
let totalPages = 1;
let currentQuery = '';
const articlesPerPage = 24;

// Toggle filter drawer
function toggleFilterDrawer() {
  filterDrawer.classList.toggle('open');
  filterOverlay.classList.toggle('active');
}

// Navigate to filter URL
function navigateToFilter(url) {
  console.log('Navigating to filter:', url);
  window.location.href = url;
}

// Fetch and display predictive search suggestions
async function fetchSuggestions(query) {
  if (!query) {
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
    return;
  }
  try {
    // const baseUrl = '{{ shop.url | escape }}';
    const baseUrl = window.location.origin;
    //   {% comment %} const baseUrl = 'https://mysimplyfun.info'; {% endcomment %}
    //const url = `${baseUrl}/search/suggest?q=${encodeURIComponent(query)}&resources[type]=article&session_id=predictive-search`;

    const url = `${baseUrl}/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article`; // Added .json; removed session_id
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, Response: ${errorText}`);
    }
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error('Response is not JSON');
    }
    const data = await response.json();
    suggestionsContainer.innerHTML = '';
    let articles = [];
    if (data.resources && data.resources.results && data.resources.results.articles) {
      articles = data.resources.results.articles;
    }
    //   {% comment %} console.log('Fetched articles:', articles); {% endcomment %}
    if (articles && articles.length > 0) {
      articles.forEach((result) => {
        const suggestion = document.createElement('div');
        suggestion.classList.add('blog-search__suggestion');
        suggestion.innerHTML = `<strong>${result.title || result.handle}</strong>`;
        suggestion.dataset.url = `/blogs/simplyfun-blog/${result.handle}`;
        suggestion.addEventListener('click', () => {
          window.location.href = suggestion.dataset.url;
          suggestionsContainer.style.display = 'none';
          searchInput.setAttribute('aria-expanded', 'false');
        });
        suggestionsContainer.appendChild(suggestion);
      });
      suggestionsContainer.style.display = 'block';
      searchInput.setAttribute('aria-expanded', 'true');
      // {% comment %} console.log('Suggestions container HTML:', suggestionsContainer.innerHTML); {% endcomment %}
    } else {
      suggestionsContainer.style.display = 'none';
      searchInput.setAttribute('aria-expanded', 'false');
    }
  } catch (error) {
    console.error('Error fetching suggestions:', error);
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
  }
}

// Perform search with div structure on the same page
async function performBlogSearch(append = false) {
  const query = searchInput.value.trim();
  if (query === '' && !append) {
    articlesContainer.innerHTML = originalArticlesHTML;
    noResults.style.display = 'none';
    resultsCount.style.display = 'none';
    resultsCount.textContent = '';
    loadMoreButton.style.display = 'none';
    if (paginationWrapper) paginationWrapper.classList.remove('hidden');
    clearButton.style.display = 'none';
    filterDrawer.classList.remove('open');
    filterOverlay.classList.remove('active');
    if (filterCloseIcon) filterCloseIcon.style.display = 'none';
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
    return;
  }

  if (!append) {
    currentQuery = query;
    currentPage = 1;
    articlesContainer.innerHTML = '';
  }

  try {
    const url = `/search?type=article&q=${encodeURIComponent(currentQuery)}&page=${currentPage}`;
    const response = await fetch(url, { method: 'GET' });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const responseHTML = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(responseHTML, 'text/html');

    const articlesHeader = Array.from(doc.querySelectorAll('h1')).find((h1) => h1.textContent.trim() === 'Articles');
    const articleGrid = articlesHeader ? articlesHeader.nextElementSibling : null;

    const pagination = doc.querySelector('.pagination');
    if (pagination) {
      const pageLinks = pagination.querySelectorAll(
        '.pagination__item:not(.pagination__item--next):not(.pagination__item--prev)',
      );
      totalPages =
        pageLinks.length > 0
          ? Math.max(...Array.from(pageLinks).map((link) => parseInt(link.textContent.trim(), 10) || 1))
          : 1;
    } else {
      totalPages = 1;
    }

    if (articleGrid && articleGrid.tagName === 'UL' && articleGrid.innerHTML.trim().length > 0) {
      const articles = articleGrid.querySelectorAll('li.grid__item');
      articles.forEach((article) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('blog-articles__article', 'article', 'fetched-article');
        const cardWrapper = document.createElement('div');
        cardWrapper.classList.add('article-card-wrapper');
        const card = document.createElement('div');
        card.classList.add('card');

        // Copy the card content
        const cardContent = article.querySelector('.card');
        if (cardContent) {
          card.innerHTML = cardContent.innerHTML;

          // Fix oversized full-unstyled-link
          const links = card.querySelectorAll('a.full-unstyled-link');
          links.forEach((link) => {
            // Ensure the link only wraps the intended content (e.g., title or image)
            const parent = link.parentElement;
            if (parent.classList.contains('card') || parent.classList.contains('card__inner')) {
              // If the link wraps the entire card or card__inner, move it to wrap only the title
              const title = card.querySelector('.card__heading');
              if (title && !title.querySelector('a.full-unstyled-link')) {
                const newLink = document.createElement('a');
                newLink.classList.add('full-unstyled-link');
                newLink.href = link.href;
                newLink.innerHTML = title.innerHTML;
                title.innerHTML = '';
                title.appendChild(newLink);
                link.remove(); // Remove the oversized link
              }
            }
          });
        }

        //   {% comment %} card.innerHTML = article.querySelector('.card').innerHTML; {% endcomment %}
        cardWrapper.appendChild(card);
        wrapper.appendChild(cardWrapper);
        if (append) {
          articlesContainer.appendChild(wrapper);
        } else {
          articlesContainer.appendChild(wrapper);
        }
      });

      noResults.style.display = 'none';
      const currentCount = articlesContainer.querySelectorAll('.blog-articles__article').length;
      const estimatedTotal = currentCount + (totalPages - currentPage) * articlesPerPage;
      resultsCount.style.display = 'block';
      resultsCount.textContent = `${currentCount} of ~${estimatedTotal} result${currentCount === 1 ? '' : 's'} found`;
      loadMoreButton.style.display = currentPage < totalPages ? 'block' : 'none';
    } else if (!append) {
      articlesContainer.innerHTML = '';
      noResults.style.display = 'block';
      resultsCount.style.display = 'block';
      resultsCount.textContent = '0 results found';
      loadMoreButton.style.display = 'none';
    }
    if (paginationWrapper) paginationWrapper.classList.add('hidden');
    clearButton.style.display = query.length > 0 ? 'block' : 'none';
    filterDrawer.classList.remove('open');
    filterOverlay.classList.remove('active');
    if (filterCloseIcon) filterCloseIcon.style.display = 'none';
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
  } catch (error) {
    console.error('Error performing search:', error);
    if (!append) {
      articlesContainer.innerHTML = '';
      noResults.style.display = 'block';
      resultsCount.style.display = 'block';
      resultsCount.textContent = '0 results found';
    }
    loadMoreButton.style.display = 'none';
    if (paginationWrapper) paginationWrapper.classList.add('hidden');
    clearButton.style.display = 'none';
    filterDrawer.classList.remove('open');
    filterOverlay.classList.remove('active');
    if (filterCloseIcon) filterCloseIcon.style.display = 'none';
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
  }
}

// Show/hide clear button and fetch suggestions on input
searchInput.addEventListener('input', () => {
  clearButton.style.display = searchInput.value.length > 0 ? 'block' : 'none';
  fetchSuggestions(searchInput.value);
});

// Handle search on Enter key or form submit
searchInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
    currentPage = 1;

    const searchTerm = searchInput.value.trim();
    if (searchTerm) {
      window.clarity('event', 'Blog Search: ' + searchTerm);
    }
    performBlogSearch();
  }
});

searchInput.form.addEventListener('submit', (e) => {
  e.preventDefault();
  suggestionsContainer.style.display = 'none';
  searchInput.setAttribute('aria-expanded', 'false');
  currentPage = 1;

  const searchTerm = searchInput.value.trim();
  if (searchTerm) {
    window.clarity('event', 'Blog Search: ' + searchTerm);
  }
  performBlogSearch();
});

// Handle clear button click to restore default state
clearButton.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  // {% comment %} console.log('Clear button clicked:', e.target); {% endcomment %}
  searchInput.value = '';
  clearButton.style.display = 'none';
  currentQuery = '';
  articlesContainer.innerHTML = originalArticlesHTML;
  noResults.style.display = 'none';
  resultsCount.style.display = 'none';
  resultsCount.textContent = '';
  loadMoreButton.style.display = 'none';

  if (paginationWrapper) {
    paginationWrapper.classList.remove('hidden');
    const pagination = paginationWrapper.querySelector('.pagination');
    if (pagination) pagination.style.display = '';
  }

  suggestionsContainer.style.display = 'none';
  searchInput.setAttribute('aria-expanded', 'false');

  filterDrawer.classList.remove('open');
  filterOverlay.classList.remove('active');
  if (filterCloseIcon) filterCloseIcon.style.display = 'none';

  // {% comment %} Hiding results div and clear all button {% endcomment %}
  const resultsHeader = document.querySelector('.blog__results-header');
  const clearAllLink = document.getElementById('clear-all-link');
  if (resultsHeader) resultsHeader.style.display = 'none';
  if (clearAllLink) {
    clearAllLink.style.display = 'none';
    clearAllLink.classList.remove('visible');
  }
});

// Handle load more button click
loadMoreButton.addEventListener('click', () => {
  currentPage++;
  performBlogSearch(true);
});

// Event listeners for filter drawer
filterButton.addEventListener('click', toggleFilterDrawer);
filterCloseIcon.addEventListener('click', toggleFilterDrawer);
filterOverlay.addEventListener('click', toggleFilterDrawer);
if (filterHeader) filterHeader.addEventListener('click', toggleFilterDrawer);

// Bind click events to filter tags for navigation
function bindFilterTags() {
  document.querySelectorAll('.block__blog-filter-content .blog__filter-tag').forEach((tag) => {
    tag.addEventListener('click', () => {
      const url = tag.dataset.url;
      if (url) {
        //   {% comment %} console.log('Navigating to filter:', url); {% endcomment %}
        navigateToFilter(url);
      }
      toggleFilterDrawer();
    });
  });
}
bindFilterTags();
filterDrawer.addEventListener('transitionend', bindFilterTags);

// Debug clicks on the document to catch unintended targets
document.addEventListener('click', (e) => {
  if (e.target.closest('.blog--search-clear')) {
    //   {% comment %} console.log('Click detected on clear button:', e.target); {% endcomment %}
  } else if (e.target.closest('a.full-unstyled-link')) {
    //   {% comment %} console.log('Click detected on article link:', e.target.href); {% endcomment %}
  } else if (!e.target.closest('.block__blog_search-filter')) {
    suggestionsContainer.style.display = 'none';
    searchInput.setAttribute('aria-expanded', 'false');
  }
});

// === SHOW RESULTS MESSAGE ONLY ON TAGGED PAGES OR SEARCH ===
const resultsHeader = document.querySelector('.blog__results-header');
const resultsMessage = document.getElementById('results-message');

function updateResultsMessage() {
  const articlesContainer = document.querySelector('#blog-articles');
  // const totalArticles = document.querySelectorAll('#blog-articles .blog-articles__article').length;

  // Count currently displayed articles (for search results or loaded content)
  const displayedArticles = articlesContainer.querySelectorAll('.blog-articles__article').length;

  const path = window.location.pathname;
  const isMainBlog = path === '/blogs/simplyfun-blog' || path === '/blogs/simplyfun-blog/';
  const taggedMatch = path.match(/\/tagged\/([^\/]+)/);
  const hasSearch = currentQuery.trim() !== '';
  const clearAllLink = document.getElementById('clear-all-link');

  // Hide entire header on main blog (no filter/search)
  if (isMainBlog && !hasSearch) {
    resultsHeader.style.display = 'none';
    if (clearAllLink) clearAllLink.classList.remove('visible');
    return;
  }

  resultsHeader.style.display = 'flex'; // use flex for layout
  if (clearAllLink) {
    clearAllLink.style.display = 'inline-flex';
    clearAllLink.classList.add('visible');
  }

  let topicName = '';
  if (taggedMatch) {
    topicName = taggedMatch[1].replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
  }

  let totalArticlesCount = displayedArticles; // default fallback

  if (hasSearch) {
    resultsMessage.innerHTML = `Showing result${
      displayedArticles !== 1 ? 's' : ''
    } for "<strong>${currentQuery}</strong>"`;
  } else if (taggedMatch) {
    // const totalArticles = {{ paginate.items }};
    const paginatedCount = articlesContainer.dataset.totalArticles
      ? parseInt(articlesContainer.dataset.totalArticles, 10)
      : displayedArticles;
    totalArticlesCount = paginatedCount;

    resultsMessage.innerHTML = `Showing <strong>${totalArticlesCount}</strong> result${
      totalArticlesCount !== 1 ? 's' : ''
    } for <strong>${topicName}</strong>`;
  }
}

// Run on load
updateResultsMessage();

// Re-run when articles change (search, load more, page load)
const observer = new MutationObserver(updateResultsMessage);
observer.observe(articlesContainer, { childList: true, subtree: true });

// Also update after search/load more
const originalPerformBlogSearch = performBlogSearch;
performBlogSearch = function (...args) {
  originalPerformBlogSearch(...args).then(() => {
    setTimeout(updateResultsMessage, 100);
  });
};

// Update when returning to main blog (e.g. clicking "All Blogs")
window.addEventListener('popstate', updateResultsMessage);
